import { createContext } from 'react';

import { GqlErrorContextType } from './GqlError.types';

export const GqlErrorContext = createContext<GqlErrorContextType>({
  errorResolver: (errorCode: string) => errorCode,
});
